/* ===========================================================
   EVENTO PRINCIPAL: Ejecutar todo cuando el DOM esté listo
   =========================================================== */
document.addEventListener("DOMContentLoaded", () => { // Espera a que el HTML esté cargado
  activarHeaderScroll();      // Llama a la función del scroll del header
  marcarEnlaceActivo();       // Llama a la función que resalta el link actual
  registrarEventosMenu();     // Llama a la función del menú móvil
  cerrarMenuClickFuera();     // Llama a la función para cerrar menú al tocar fuera
  inicializarReloj();         // Configura el selector de hora (Flatpickr)
  initFormularioCitaOrienta();       // Configura el envío de datos a Google
  initFormularioSolicitudTitulo();  // Configura el envío de datos a Google
});

/* ===========================================================
   FUNCIONES DEL FORMULARIO Y RELOJ
   =========================================================== */

function inicializarReloj() {
  const inputHora = document.querySelector("#hora"); // Busca el campo de entrada de hora
  const mensajeError = document.querySelector("#error-hora"); // Busca el span del mensaje de error

  if (inputHora) { // Solo si el input existe en esta página...
    const ahora = new Date(); // Obtiene la fecha y hora actual del sistema
    const tiempoTotalActual = (ahora.getHours() * 60) + ahora.getMinutes(); // Convierte hora actual a minutos

    const minLimiteMinutos = (7 * 60) + 20; // Define 7:20 AM en minutos (440)
    const maxLimiteMinutos = (15 * 60) + 0;  // Define 3:00 PM en minutos (900)

    // Si la hora actual es válida, úsala; si no, pon las 7:20 AM por defecto
    let horaInicial = (tiempoTotalActual >= minLimiteMinutos && tiempoTotalActual <= maxLimiteMinutos)
      ? ahora
      : "07:20";

    flatpickr(inputHora, { // Inicializa la librería Flatpickr en el input
      enableTime: true, // Habilita la selección de tiempo
      noCalendar: true, // Desactiva el calendario, solo muestra reloj
      dateFormat: "h:i K", // Formato: Hora:Minutos AM/PM
      time_24hr: false, // Usa formato de 12 horas
      minTime: "07:20", // Límite inferior visual
      maxTime: "15:00", // Límite superior visual
      minuteIncrement: 10, // Los minutos saltan de 10 en 10
      defaultDate: horaInicial, // Establece la hora que calculamos antes
      onOpen: () => { if (mensajeError) mensajeError.style.display = "none"; }, // Oculta error al abrir
      onClose: function (selectedDates, dateStr, instance) { // Al cerrar el reloj...
        const horaSeleccionada = selectedDates[0]; // Captura la fecha/hora elegida
        if (horaSeleccionada) { // Si el usuario eligió algo...
          const tiempoTotal = (horaSeleccionada.getHours() * 60) + horaSeleccionada.getMinutes(); // Calcula minutos
          if (tiempoTotal < minLimiteMinutos || tiempoTotal > maxLimiteMinutos) { // Si está fuera de rango...
            if (mensajeError) { // Si existe el elemento de error...
              mensajeError.textContent = "El horario debe ser de 7:20 AM a 3:00 PM"; // Cambia el texto
              mensajeError.style.display = "block"; // Muestra el mensaje
            }
            instance.clear(); // Borra la hora inválida del campo
          }
        }
      }
    });
  }
}

/**
 * Maneja el envío de datos a Google Apps Script 
 */  //formsCitasOrienta
function initFormularioCitaOrienta() {
  const scriptURL = 'https://script.google.com/macros/s/AKfycbxfP_sZRegm3rijGqkphck6TJidELRZc8qrq31gYru_BqeoYJaZu7nPBoHTqoYcOszm/exec'; // URL de tu Google Script
  const form = document.querySelector('#formulario-cita'); // Busca el formulario por su ID

  if (!form) return; // Si no hay formulario en esta página, sale de la función

  form.addEventListener('submit', e => { // Escucha cuando el usuario presiona "Enviar"
    e.preventDefault(); // Evita que la página se recargue automáticamente

    const submitBtn = form.querySelector('.boton-azul'); // Busca el botón de envío
    const originalText = submitBtn.value || submitBtn.textContent; // Guarda el texto original ("Enviar Solicitud")

    submitBtn.value = "Enviando..."; // Cambia el texto del botón para dar feedback
    submitBtn.disabled = true; // Deshabilita el botón para evitar múltiples envíos
    submitBtn.style.opacity = "0.7"; // Lo pone un poco transparente visualmente

    fetch(scriptURL, { // Envía los datos a la URL de Google
      method: 'POST', // Usa el método POST para enviar información
      body: new FormData(form) // Empaqueta todos los campos del formulario automáticamente
    })
      .then(response => { // Si la respuesta es exitosa...
        window.location.href = 'mensajeConfirmacion.html'; // Redirige a la página de agradecimiento
      })
      .catch(error => { // Si ocurre un error en la conexión...
        console.error('Error!', error.message); // Muestra el error en la consola
        alert('Hubo un error al enviar. Por favor, intenta de nuevo.'); // Muestra alerta al usuario

        submitBtn.value = originalText; // Restaura el texto original del botón
        submitBtn.disabled = false; // Vuelve a habilitar el botón
        submitBtn.style.opacity = "1"; // Restaura la opacidad original
      });
  });
}
// Maneja el envío de datos a Google Apps Script  FormularioSolicitudTitulo
function initFormularioSolicitudTitulo() {

  // ---------------------------------------------
  // Función unificada para validar archivos (PDF + 5MB)
  // ---------------------------------------------
  function validarArchivo(file, maxMB = 5) {
    if (!file) {
      return { ok: false, error: "Debe seleccionar un archivo PDF." };
    }

    const esPDF = file.type === "application/pdf";
    const tamanoMB = file.size / 1024 / 1024;

    if (!esPDF) {
      return { ok: false, error: "El archivo debe ser un PDF válido." };
    }

    if (tamanoMB > maxMB) {
      return { ok: false, error: `El archivo supera el límite de ${maxMB}MB.` };
    }

    return { ok: true };
  }

  // ---------------------------------------------
  // Mostrar error dentro del <span> asociado al input
  // ---------------------------------------------
  function mostrarErrorCampo(inputElement, mensaje) {

    // Se asume estructura:
    // <span><p>Texto aquí</p></span>
    const spanContenedor = inputElement.previousElementSibling;
    const mensajeP = spanContenedor ? spanContenedor.querySelector("p") : null;

    if (!mensajeP) return; // Seguridad

    if (mensaje) {
      mensajeP.textContent = mensaje;
      mensajeP.style.color = "#dc3545";
      inputElement.style.borderColor = "#dc3545";
    } else {
      mensajeP.textContent = "Máximo 5MB por archivo";
      mensajeP.style.color = "";
      inputElement.style.borderColor = "";
    }
  }

  // ---------------------------------------------
  // Conversión a Base64
  // ---------------------------------------------
  const toBase64 = file => new Promise((resolve, reject) => {
    if (!file) resolve(null);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve({
      data: reader.result,
      type: file.type,
      name: file.name
    });
    reader.onerror = error => reject(error);
  });

  // ---------------------------------------------
  // Validación inmediata al seleccionar archivo
  // ---------------------------------------------
  const inputsArchivo = document.querySelectorAll('fieldset input[type="file"]');

  inputsArchivo.forEach(input => {
    input.addEventListener('change', function () {

      const file = this.files[0];
      const resultado = validarArchivo(file);

      if (resultado.ok) {
        mostrarErrorCampo(this, null);
        this.style.borderColor = "#28a745";
      } else {
        mostrarErrorCampo(this, resultado.error);
        this.value = "";
      }
    });
  });

  // ---------------------------------------------
  // Manejo del formulario completo
  // ---------------------------------------------
  const formulario = document.getElementById('formulario-reposicion');
  const MAX_SIZE_MB = 5;

  if (formulario) {
    formulario.addEventListener('submit', async (e) => {
      e.preventDefault();

      const inputsArchivos = [
        document.getElementById('cedulaAdjunta'),
        document.getElementById('declaracionJurada'),
        document.getElementById('formularioReposicion')
      ];

      // Limpiar errores previos
      inputsArchivos.forEach(input => mostrarErrorCampo(input, null));

      // Honeypot
      const botField = formulario.querySelector('input[name="bot-field"]').value;
      if (botField !== "") return;

      // Botón
      const btn = formulario.querySelector('input[type="submit"]') || formulario.querySelector('.boton-dorado');
      const originalBtnText = btn.value || btn.textContent;

      // Validación final de archivos
      let hayError = false;

      inputsArchivos.forEach(input => {
        const file = input.files[0];
        const resultado = validarArchivo(file, MAX_SIZE_MB);

        if (!resultado.ok) {
          mostrarErrorCampo(input, resultado.error);
          hayError = true;
        }
      });

      if (hayError) return;

      // Feedback visual
      btn.value = "Enviando solicitud...";
      btn.innerText = "Enviando solicitud...";
      btn.disabled = true;
      btn.style.opacity = "0.7";

      try {
        // Captura de archivos
        const fileCedula = document.getElementById('cedulaAdjunta').files[0];
        const fileDeclaracion = document.getElementById('declaracionJurada').files[0];
        const fileFormulario = document.getElementById('formularioReposicion').files[0];

        // Conversión en paralelo
        const [base64Cedula, base64Declaracion, base64Formulario] = await Promise.all([
          toBase64(fileCedula),
          toBase64(fileDeclaracion),
          toBase64(fileFormulario)
        ]);

        // Construcción del payload
        const payload = {
          nombre: document.getElementById('nombre').value,
          cedula: document.getElementById('cedula').value,
          correo: document.getElementById('correo').value,
          telefono: document.getElementById('telefono').value,
          tipoTitulo: document.getElementById('tipoTitulo').value,
          anioGraduacion: document.getElementById('anioGraduacion').value,
          motivo: document.getElementById('motivo').value,
          archivoCedula: base64Cedula,
          archivoDeclaracion: base64Declaracion,
          archivoFormulario: base64Formulario
        };

        // URL del Apps Script  FormularioSolicitudTitulo
        const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbw0YMD3r5zUkzI8Y1tiEtJp-9dpLqBWhrDXIT8TxPWpvYzKYP1SRtItBdQtmcGL7y47/exec";

        await fetch(SCRIPT_URL, {
          method: 'POST',
          mode: 'no-cors',
          cache: 'no-cache',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        window.location.href = 'mensajeConfirmacion.html';

      } catch (error) {
        console.error("Error en el envío:", error);
        alert("Hubo un problema al enviar la solicitud. Por favor, intente de nuevo.");

        btn.value = originalBtnText;
        btn.innerText = originalBtnText;
        btn.disabled = false;
        btn.style.opacity = "1";
      }
    });
  }
}
// function initFormularioSolicitudTitulo() {
//   /**
//   * Lógica para procesar el formulario de reposición, 
//   * validar tamaño de archivos, convertir a Base64 y enviar.
//   */

//   const formulario = document.getElementById('formulario-reposicion');
//   const MAX_SIZE = 5 * 1024 * 1024; // 5 MB en bytes

//   /**
//    * Función para mostrar u ocultar errores sobre los campos
//    */
//   const mostrarErrorCampo = (inputElement, mensaje) => {
//     // Buscamos un elemento de error existente o lo creamos
//     let errorDisplay = inputElement.parentElement.querySelector('.error-mensaje');

//     if (mensaje) {
//       if (!errorDisplay) {
//         errorDisplay = document.createElement('span');
//         errorDisplay.className = 'error-mensaje';
//         errorDisplay.style.color = '#ef4444'; // Rojo suave
//         errorDisplay.style.fontSize = '0.875rem';
//         errorDisplay.style.marginTop = '0.25rem';
//         errorDisplay.style.display = 'block';
//         inputElement.parentElement.appendChild(errorDisplay);
//       }
//       errorDisplay.innerText = mensaje;
//       inputElement.style.borderColor = '#ef4444';
//     } else {
//       if (errorDisplay) errorDisplay.remove();
//       inputElement.style.borderColor = '';
//     }
//   };

//   /**
//    * Función auxiliar para convertir un archivo a Base64
//    */
//   const toBase64 = file => new Promise((resolve, reject) => {
//     if (!file) resolve(null);
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve({
//       data: reader.result,
//       type: file.type,
//       name: file.name
//     });
//     reader.onerror = error => reject(error);
//   });

//   // Inicialización del evento del formulario
//   if (formulario) {
//     formulario.addEventListener('submit', async (e) => {
//       e.preventDefault();

//       // 1. Limpiar errores previos
//       const inputsArchivos = [
//         document.getElementById('cedulaAdjunta'),
//         document.getElementById('declaracionJurada'),
//         document.getElementById('formularioReposicion')
//       ];
//       inputsArchivos.forEach(input => mostrarErrorCampo(input, null));

//       // 2. Verificación de Honeypot (Seguridad)
//       const botField = formulario.querySelector('input[name="bot-field"]').value;
//       if (botField !== "") return;

//       // 3. Definir botón y estado inicial
//       const btn = formulario.querySelector('input[type="submit"]') || formulario.querySelector('.boton-dorado');
//       const originalBtnText = btn.value || btn.textContent;

//       // 4. Validar tamaño de archivos
//       let hayError = false;
//       for (let input of inputsArchivos) {
//         if (input.files[0] && input.files[0].size > MAX_SIZE) {
//           mostrarErrorCampo(input, `El archivo es muy pesado (máx. 5MB).`);
//           hayError = true;
//         }
//       }

//       if (hayError) return;

//       // 5. Feedback visual en el botón
//       btn.value = "Enviando solicitud y archivos...";
//       btn.innerText = "Enviando solicitud y archivos...";
//       btn.disabled = true;
//       btn.style.opacity = "0.7";

//       try {
//         // 6. Capturar los archivos de los inputs
//         const fileCedula = document.getElementById('cedulaAdjunta').files[0];
//         const fileDeclaracion = document.getElementById('declaracionJurada').files[0];
//         const fileFormulario = document.getElementById('formularioReposicion').files[0];

//         // 7. Convertir todos los archivos en paralelo
//         const [base64Cedula, base64Declaracion, base64Formulario] = await Promise.all([
//           toBase64(fileCedula),
//           toBase64(fileDeclaracion),
//           toBase64(fileFormulario)
//         ]);

//         // 8. Construir el objeto con todos los campos
//         const payload = {
//           nombre: document.getElementById('nombre').value,
//           cedula: document.getElementById('cedula').value,
//           correo: document.getElementById('correo').value,
//           telefono: document.getElementById('telefono').value,
//           tipoTitulo: document.getElementById('tipoTitulo').value,
//           anioGraduacion: document.getElementById('anioGraduacion').value,
//           motivo: document.getElementById('motivo').value,
//           archivoCedula: base64Cedula,
//           archivoDeclaracion: base64Declaracion,
//           archivoFormulario: base64Formulario
//         };

//         // 9. URL de tu Google Apps Script  solicitudReposicionTitulo
//         const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbyM_c6-RNw9XD7qzLy4kH6x70Dc-nuMJGe0VBf-f1K7ZTQ53AFpefCzzW4Zj8PT0SGM/exec";

//         // 10. Envío de datos mediante Fetch
//         await fetch(SCRIPT_URL, {
//           method: 'POST',
//           mode: 'no-cors',
//           cache: 'no-cache',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify(payload)
//         });
//         //const folderId = "1rGV0lfW-H_hSqPinklVY0mxyI5IoPvcN"; 
//         // 11. Éxito: Redirección
//         window.location.href = 'mensajeConfirmacion.html';

//       } catch (error) {
//         console.error("Error en el envío:", error);
//         alert("Hubo un problema al enviar la solicitud. Por favor, intente de nuevo.");

//         // Restaurar botón en caso de error
//         btn.value = originalBtnText;
//         btn.innerText = originalBtnText;
//         btn.disabled = false;
//         btn.style.opacity = "1";
//       }
//     });
//   }
// }
/* ===========================================================
   FUNCIONES DE NAVEGACIÓN (HEADER Y MENÚ)
   =========================================================== */

function activarHeaderScroll() {
  window.addEventListener('scroll', () => { // Escucha el movimiento del scroll del ratón
    const header = document.querySelector('.header'); // Busca el elemento header
    if (header) { // Si existe el header...
      // Si el scroll bajó más de 50px añade clase 'activa', si no, la quita
      window.scrollY > 50 ? header.classList.add('activa') : header.classList.remove('activa');
    }
  });
}

function marcarEnlaceActivo() {
  const enlaces = document.querySelectorAll(".navegacion a"); // Selecciona todos los links del menú
  let rutaActual = window.location.pathname.toLowerCase().replace(/^\/|\.html$/g, ""); // Limpia la URL actual

  enlaces.forEach(enlace => { // Recorre cada link uno por uno
    let rutaEnlace = enlace.getAttribute("href").toLowerCase().replace(/^\/|\.html$/g, ""); // Limpia el href del link
    if (rutaEnlace === rutaActual || (rutaActual === "" && rutaEnlace === "index")) { // Si coinciden...
      enlace.classList.add("activo"); // Añade la clase CSS 'activo' para resaltarlo
    }
  });
}

function registrarEventosMenu() {
  const mobileMenu = document.querySelector('.mobile-menu'); // Busca el icono de hamburguesa
  if (mobileMenu) { // Si existe...
    mobileMenu.addEventListener('click', () => { // Al hacer click...
      const navegacion = document.querySelector('.navegacion'); // Busca el menú de navegación
      if (navegacion) navegacion.classList.toggle('mostrar'); // Muestra u oculta el menú
    });
  }
}

function cerrarMenuClickFuera() {
  document.addEventListener('click', (event) => { // Escucha cualquier click en toda la pantalla
    const navegacion = document.querySelector('.navegacion'); // Referencia al menú
    const mobileMenu = document.querySelector('.mobile-menu'); // Referencia al botón hamburguesa

    if (navegacion && navegacion.classList.contains('mostrar')) { // Si el menú está abierto...
      // Si el click NO fue en el menú y NO fue en el botón hamburguesa...
      if (!navegacion.contains(event.target) && !mobileMenu.contains(event.target)) {
        navegacion.classList.remove('mostrar'); // Cierra el menú
      }
    }
  });
}